var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterHeadIndividual7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 146 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#332d28;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill-rule:evenodd;}.cls-4{fill:#edba8a;}.cls-5{fill:#ad7b4c;}.cls-6{fill:#fcdbbd;}.cls-7{fill:#543e2e;}.cls-8{fill:#222c30;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 1,
    width: 131,
    height: 115
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26,106.93V74c0-25.91,21.42-46.91,47.32-46.91S120.6,48.13,120.6,74h0v32.89l-94.64,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.88,79.56a7.82,7.82,0,1,0,7.82,7.82,7.82,7.82,0,0,0-7.82-7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.88,83.47a3.91,3.91,0,1,0,3.91,3.91,3.9,3.9,0,0,0-3.91-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.71,79.56a7.82,7.82,0,1,0,7.82,7.82,7.82,7.82,0,0,0-7.82-7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.71,83.47a3.91,3.91,0,1,0,3.91,3.91,3.9,3.9,0,0,0-3.91-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112,71.34v35.57a38.72,38.72,0,1,1-77.44,0V71.34S47.13,55.59,72,55.59a58.69,58.69,0,0,1,40,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.09,93c0,14.51-3.82,26.28-8.53,26.28s-14.94-11.52-14.94-26S25.86,66.7,30.56,66.7,39.09,78.46,39.09,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.28,93c0,14.51,3.82,26.28,8.53,26.28s14.94-11.52,14.94-26S120.51,66.7,115.81,66.7,107.28,78.46,107.28,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61,82.19a1.1,1.1,0,0,1-1.44,1.65,5.49,5.49,0,0,0-8.11,1,1.09,1.09,0,0,1-1.79-1.25A7.65,7.65,0,0,1,61,82.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M95.32,83.75a1.09,1.09,0,1,1-1.82,1.19,5.5,5.5,0,0,0-8.08-1.24A1.09,1.09,0,1,1,84,82a7.65,7.65,0,0,1,11.29,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M56.4,87.29a3.24,3.24,0,1,1-3.24,3.24,3.25,3.25,0,0,1,3.24-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M88.84,87.29a3.24,3.24,0,1,1-3.25,3.24,3.24,3.24,0,0,1,3.25-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.31,101.15l-.07-6.84a1.71,1.71,0,0,0-3.41,0h0l.06,5.14-1.72,0a5.13,5.13,0,0,0,.11,10.26l3.42-.05A1.71,1.71,0,0,0,75.39,108Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterHeadIndividual7);
export default __webpack_public_path__ + "static/media/character-head-individual-7.0f33f93e22597e2f4f8b8c2fd5a9d029.svg";
export { ForwardRef as ReactComponent };